import {
    faArrowLeft,
    faCircleCheck,
    faPersonToDoor,
    faPlus,
    faUpload,
    type IconDefinition,
} from "@fortawesome/pro-regular-svg-icons";

export const regularIcons: IconDefinition[] = [
    faArrowLeft,
    faPersonToDoor,
    faPlus,
    faCircleCheck,
    faUpload,
];
